import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rise",
  "use": "icon-rise-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rise\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0L0 4.5H2.5V9H5.5V4.5H8L4 0Z\" fill=\"#1EC239\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol